import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FormBloc from "../../../../bloc/forms_bloc";
import GeneralBloc from "../../../../bloc/general_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import UtilBloc from "../../../../bloc/util_bloc";
import Config from "../../../../Config";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import AppTextField from "../../../component/app_text_field/app_text_field";
import {
    decimalNumberValidation,
    emailValidation,
    generalValidation,
    nameValidation,
    numberValidation,
    officeNumberValidation,
    phoneNumberValidation
} from "../../../component/app_validation";
import "./proposal_form.css";
import moment from "moment";

class PersonalDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            personalDetailsData: {
                representativeName: null,
                branchCode: null,
                staffCode: null,
                proposalDate: null,
                name: null,
                gender: null,
                title: null,
                idType: null,
                addIDType: null,
                addIDNo: null,
                idNo: null,
                dob: null,
                maritalStatus: null,
                race: null,
                religion: null,
                isMalaysian: null,
                isLivingInMalaysia: null,
                country: null,
                corrCountry: null,
                correspondenceAddress: null,
                correspondenceAddress2: null,
                correspondenceAddress3: null,
                isPermamentAddressCorrespondenceAddress: null,
                isResidentialAddressCorrespondenceAddress: null,
                state: null,
                corrState: null,
                corrPostcode: null,
                city: null,
                corrCity: null,
                permanentAddress: null,
                residentialAddress: null,
                residentialAddress2: null,
                residentialAddress3: null,
                residentialState: null,
                residentialCity: null,
                residentialCountry: null,
                residentialPostcode: null,
                occupation: null,
                annualIncome: null,
                exactAnnualIncome: null,
                natureBusiness: null,
                exactDuties: null,
                mobileNo: null,
                officePhoneNo: null,
                email: null,
                companyName: null,
                companyAddress: null,
                companyAddress2: null,
                companyAddress3: null,
                companyCountry: null,
                companyState: null,
                companyPostcode: null,
                companyCity: null,
                placeOfBirth: null,
                placeOfBirth2: null,
                placeOfBirth3: null,
                preferContactMode: null,
            },

            errorMessage: 'Fill in the required field.',

            titleErrMsg: null,
            maritalStatusErrMsg: null,
            raceErrMsg: null,
            religionErrMsg: null,
            isMalaysianErrMsg: null,
            isLivingInMalaysiaErrMsg: null,
            countryErrMsg: null,
            correspondenceAddressErrMsg: null,
            stateErrMsg: null,
            postcodeErrMsg: null,
            cityErrMsg: null,
            permanentAddressErrMsg: null,
            residentialAddressErrMsg: null,
            occupationErrMsg: null,
            annualIncomeErrMsg: null,
            natureBusinessErrMsg: null,
            exactDutiesErrMsg: null,
            mobileNoErrMsg: null,
            officePhoneNoErrMsg: null,
            emailErrMsg: null,
            companyNameErrMsg: null,
            companyAddressErrMsg: null,
            companyCountryErrMsg: null,
            companyStateErrMsg: null,
            companyPostcodeErrMsg: null,
            companyCityErrMsg: null,
            placeOfBirthErrMsg: null,
            salutationList: null,
            countryList: null,
            stateList: null,
            foreignStateList: null,
            corrForeignStateList: null,
            companyForeignStateList: null,
            residentialForeignStateList: null,
            cityList: null,
            addressCityList: null,
            companyCityList: null,
            postcodeList: null,
            addressPostcodeList: null,
            companyPostcodeList: null,
            displayNob: null,
            displayOcc: null,
        };
        // this.validate()
    }

    initiateData = async () => {
        let formData = this.props.value;
        let stateData = this.state.personalDetailsData;
        let occupation = null;
        let natureBusiness = null;
        await Promise.all(Object.keys(formData).map(async function (key) {
            stateData[key] = formData[key];
            if (key == 'occupation') {
                occupation = await FormBloc.getOccupationNameByCode(formData[key]);
            }
            if (key == 'natureBusiness') {
                natureBusiness = await FormBloc.getNobNameByCode(formData['occupation'], formData[key]);
            }
        }));
        this.setState({ personalDetailsData: stateData, displayOcc: occupation, displayNob: natureBusiness });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value && this.props.value.isMalaysian) {
            this.handleIsForeigner(this.props.value.isMalaysian);
        }
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    getFormFields() {
        return this.props.fields;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
        this.getFormOptList();
    }
    async getFormOptList() {
        this.setState({ loading: true });
        let countryList = await FormBloc.getCountryList();
        let stateList = await FormBloc.getStateList();
        let salutationList = await FormBloc.getSalutationList();
        this.setState({
            countryList: countryList.data,
            stateList: stateList.data,
            salutationList: salutationList.data,
            loading: false
        });
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    onValidateForm = () => {
        const { personalDetailsData } = this.state;
        let validated = UtilBloc.personalDetailsDataValidation(personalDetailsData);
        this.setPropValidation(validated);
        this.setPropValue(personalDetailsData);
        return validated;
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    setPropValue = () => {
        let valueobj = this.state.personalDetailsData;
        this.props.onChange(valueobj);
    }

    handleValueChange = (field, val) => {
        let data = this.state.personalDetailsData;
        data[field] = val;
        if (
            (data['isMalaysian'] == 'Yes' && data['isLivingInMalaysia'] == 'No') ||
            (data['isMalaysian'] == 'Yes' && data['isLivingInMalaysia'] == 'No' && data['companyCountry'] != 'MYS' && data['companyCountry'] != 'SGP' && data['companyCountry'] != null) ||
            ((data['isMalaysian'] != 'Yes' || data['idType'] == 'Foreigner - Passport No.'))
        ) {
            this.handleIsForeignTravel(true);
        } else {
            this.handleIsForeignTravel(false);
        }

        if (field == 'name' || field == 'companyName') {
            const capitalizedName = UtilBloc.capitalizeWords(val);
            const convertApostrophe = capitalizedName.replace(/[\u2018\u2019\u0091\u0092]/g, "'");
            data[field] = convertApostrophe;
        }

        if (field == 'isMalaysian') {
            this.handleIsForeigner(val)
            if (val == 'Yes') {
                data.country = 'MYS';
                data.state = null;
                data.city = null;
                data.companyCountry = null;
                data.companyState = null;
                data.companyCity = null;
                data.companyPostcode = null;
                this.setState({
                    personalDetailsData: {
                        ...this.state.personalDetailsData,
                        country: 'MYS',
                        state: null,
                        city: null,
                        companyCountry: null,
                        companyState: null,
                        companyCity: null,
                        companyPostcode: null
                    }
                });
            } else {
                data.country = '';
                data.state = null;
                data.city = null;
            }
        }
        if (field == 'maritalStatus') {
            this.handleMaritalStatusChange(val)
        }
        if (field == 'isLivingInMalaysia' && val == 'Yes') {
            data.corrCountry = 'MYS';
            data.corrState = null;
            data.corrCity = null;
            data.corrPostcode = null;
            data.residentialCountry = 'MYS';
            data.residentialState = null;
            data.residentialCity = null;
            data.residentialPostcode = null;
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    corrCountry: 'MYS',
                    corrState: null,
                    corrCity: null,
                    corrPostcode: null,
                    residentialCountry: 'MYS',
                    residentialState: null,
                    residentialCity: null,
                    residentialPostcode: null
                }
            });
        }
        if (field == 'isLivingInMalaysia' && val == 'No') {
            data.corrCountry = null;
            data.corrState = null;
            data.corrCity = null;
            data.corrPostcode = null;
            data.residentialCountry = null;
            data.residentialState = null;
            data.residentialCity = null;
            data.residentialPostcode = null;
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    corrCountry: null,
                    corrState: null,
                    corrCity: null,
                    corrPostcode: null,
                    residentialCountry: null,
                    residentialState: null,
                    residentialCity: null,
                    residentialPostcode: null
                }
            });
        }
        if (field == 'country' && val == 'MYS') {
            data.isLivingInMalaysia = 'Yes';
        }
        if (field == 'state') {
            FormBloc.getCityList(val).then((res) => { this.setState({ cityList: res.data }) });
            data.city = null;
        }
        if (field == 'corrState') {
            FormBloc.getCityList(val).then((res) => { this.setState({ addressCityList: res.data }) });
            data.corrPostcode = null;
            data.corrCity = null;
        }
        if (field == 'corrCity') {
            data.corrPostcode = null;
            if (data.corrState && val) {
                FormBloc.getPostcodeList(data.corrState, val).then((res) => { this.setState({ addressPostcodeList: res.data }) });
            }
        }
        if (field == 'residentialState') {
            FormBloc.getCityList(val).then((res) => { this.setState({ residentialCityList: res.data }) });
            data.residentialPostcode = null;
            data.residentialCity = null;
        }
        if (field == 'residentialCity') {
            data.residentialPostcode = null;
            if (data.residentialState && val) {
                FormBloc.getPostcodeList(data.residentialState, val).then((res) => { this.setState({ residentialPostcodeList: res.data }) });
            }
        }
        if (field == 'country' && val != 'MYS') {
            data.state = null;
            data.city = null;
            FormBloc.getStateByCountryCode(val).then((res) => { this.setState({ foreignStateList: res.data }) });
        }
        if (field == 'country' && val == 'MYS') {
            this.setState({ foreignStateList: null });
        }

        if (field == 'corrCountry') {
            data.residentialCountry = val;
            if (val != 'MYS') {
                data.corrState = null;
                data.corrCity = null;
                data.corrPostcode = null;
                data.residentialState = null;
                data.residentialCity = null;
                data.residentialPostcode = null;
                FormBloc.getStateByCountryCode(val).then((res) => {
                    this.setState({
                        corrForeignStateList: res.data,
                        residentialForeignStateList: res.data
                    })
                });
                this.setState({
                    personalDetailsData: {
                        ...this.state.personalDetailsData,
                        corrState: null,
                        corrCity: null,
                        corrPostcode: null
                    }
                });
            }
        }

        if (field == 'corrCountry' && val == 'MYS') {
            data.corrState = null;
            data.corrCity = null;
            data.corrPostcode = null;
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    corrState: null,
                    corrCity: null,
                    corrPostcode: null
                },
                corrForeignStateList: null,
                residentialForeignStateList: null
            });
        }
        if (field == 'companyCountry' && val != 'MYS') {
            data.companyState = null;
            data.companyPostcode = null;
            data.companyCity = null;
            FormBloc.getStateByCountryCode(val).then((res) => { this.setState({ companyForeignStateList: res.data }) });
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    companyState: null,
                    companyCity: null,
                    companyPostcode: null
                }
            });
        }
        if (field == 'companyCountry' && val == 'MYS') {
            data.companyState = null;
            data.companyPostcode = null;
            data.companyCity = null;
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    companyState: null,
                    companyCity: null,
                    companyPostcode: null
                },
                companyForeignStateList: null
            });
        }
        if (field == 'residentialCountry' && val != 'MYS') {
            data.residentialState = null;
            data.residentialPostcode = null;
            data.residentialCity = null;
            FormBloc.getStateByCountryCode(val).then((res) => { this.setState({ residentialForeignStateList: res.data }) });
        }
        if (field == 'residentialCountry' && val == 'MYS') {
            this.setState({ residentialForeignStateList: null });
        }
        if (field == 'companyState') {
            data.companyPostcode = null;
            data.companyCity = null;
            FormBloc.getCityList(val).then((res) => { this.setState({ companyCityList: res.data }) });
        }
        if (field == 'companyCity') {
            data.companyPostcode = null;
            if (data.companyState && val) {
                FormBloc.getPostcodeList(data.companyState, val).then((res) => { this.setState({ companyPostcodeList: res.data }) });
            }
        }
        if (field == 'isPermamentAddressCorrespondenceAddress' && val == 'Yes') {
            data.permanentAddress = data.correspondenceAddress;
        }
        if (field == 'isPermamentAddressCorrespondenceAddress' && val == 'No') {
            data.permanentAddress = null;
        }

        if (field == 'correspondenceAddress' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialAddress = val;
        }
        if (field == 'correspondenceAddress2' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialAddress2 = val;
        }
        if (field == 'correspondenceAddress3' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialAddress3 = val;
        }
        if (field == 'corrState' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialState = val;
        }
        if (field == 'corrCity' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialCity = val;
        }
        if (field == 'corrPostcode' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialPostcode = val;
        }

        if (field == 'isResidentialAddressCorrespondenceAddress' && val == 'Yes') {
            data.residentialAddress = data.correspondenceAddress;
            data.residentialAddress2 = data.correspondenceAddress2;
            data.residentialAddress3 = data.correspondenceAddress3;
            data.residentialState = data.corrState;
            data.residentialCity = data.corrCity;
            data.residentialPostcode = data.corrPostcode;
            data.residentialCountry = data.corrCountry;
        }
        if (field == 'isResidentialAddressCorrespondenceAddress' && val == 'No') {
            data.residentialAddress = null;
            data.residentialAddress2 = null;
            data.residentialAddress3 = null;
            data.residentialState = null;
            data.residentialCity = null;
            data.residentialPostcode = null;
            data.residentialCountry = data.corrCountry;
        }
        let validation = this.onValidateForm();
        console.log("validation : ", validation)
    }

    handleIsForeigner(val) {
        if (val == 'Yes') {
            this.props.handleForeignerQuestionnaireOpen(false);
        } else {
            this.props.handleForeignerQuestionnaireOpen(true);
        }
    }

    handleIsForeignTravel(val) {
        this.props.handleForeignTravelQuestionnaireOpen(val);
    }

    handleMaritalStatusChange(val) {
        this.props.handleMaritalStatusChange(val);
    }

    // permanant start
    handleIsPermamentAddressCorrespondenceAddress = (val) => {
        if (val === 'Yes') {
            this.setState({
                isPermamentAddressCorrespondenceAddress: val,
                permanentAddress: this.state.personalDetailsData.correspondenceAddress
            });
        } else {
            this.setState({ isPermamentAddressCorrespondenceAddress: val })
        }
    }
    handlePermamentCountryChange = (val) => {
        this.setState({ notSameAsPermanantCountry: val });
    }
    handlePermamentAddressChange = (val) => {
        this.setState({ notSameAsPermanantAddress: val });
    }
    handlePermamentCityChange = (val) => {
        this.setState({ notSameAsPermanantCity: val });
    }
    handlePermamentStateChange = (val) => {
        this.setState({ notSameAsPermanantState: val });
    }
    handlePermamentPostcodeChange = (val) => {
        this.setState({ notSameAsPermanantPostcode: val });
    }
    // permanant end

    //residential strat
    handleIsResidentialAddressCorrespondenceAddress = (val) => {
        if (val === 'Yes') {
            this.setState({
                isResidentialAddressCorrespondenceAddress: val,
                residentialAddress: this.state.personalDetailsData.correspondenceAddress
            });
        } else {
            this.setState({ isResidentialAddressCorrespondenceAddress: val })
        }
    }
    handleResidentialCountryChange = (val) => {
        this.setState({ notSameAsResidentialCountry: val });
    }
    handleResidentialAddressChange = (val) => {
        this.setState({ notSameAsResidentialAddress: val });
    }
    handleResidentialCityChange = (val) => {
        this.setState({ notSameAsResidentialCity: val });
    }
    handleResidentialStateChange = (val) => {
        this.setState({ notSameAsResidentialState: val });
    }
    handleResidentialPostcodeChange = (val) => {
        this.setState({ notSameAsResidentialPostcode: val });
    }
    //residential end

    handleAnnualIncomeChange = (val) => {
        this.setState({ annualIncome: val });
    }
    handleExactDutiesChange = (val) => {
        this.setState({ exactDuties: val });
    }
    handleMobileNo = (val) => {
        this.setState({ mobileNo: val });
    }
    handleOfficePhoneNoChange = (val) => {
        this.setState({ officePhoneNo: val });
    }
    handleEmailChange = (val) => {
        this.setState({ email: val });
    }
    handleCompanyNameChange = (val) => {
        this.setState({ companyName: val });
    }
    handleCompanyAddressChange = (val) => {
        this.setState({ companyAddress: val });
    }
    handleCompanyCountryChange = (val) => {
        this.setState({ companyCountry: val });
    }
    handleCompnayStateChange = (val) => {
        this.setState({ companyState: val });
    }
    handleCompnayPostcodeChange = (val) => {
        this.setState({ companyPostcode: val });
    }
    handleCompanyCityChange = (val) => {
        this.setState({ companyCity: val });
    }

    showerror = (val) => {
        return val !== null && UtilBloc.isNullOrEmpty(val)
    }
    emailValidation = (val) => {
        return val !== null && UtilBloc.emailValidation(val)
    }
    showExtraFormError = (parent, val, ind) => {
        if (parent === ind) {
            return val !== null && UtilBloc.isNullOrEmpty(val)
        }
        else
            return false
    }

    representativeForm(data) {
        return (
            <AppTextField
                title={data.title}
                type={'text'}
                disabled={true}
                value={data.value}
            />
        )
    }

    personCoveredForm(data, onChange, type = 'text', placeholder, prefix = '', suffix = '') {
        if (type === 'select') {
            return (
                <AppSelectField
                    title={data.title}
                    value={data.value}
                    placeholder={placeholder}
                    options={Config.quotation.optionItem.gender}
                    onChange={onChange}
                />
            )
        }
        else if (type === 'selectButton') {
            return (
                <AppSelectButton
                    title={data.title}
                    value={data.value}
                    handleNegativePress={() => onChange('No')}
                    handlePositivePress={() => onChange('Yes')}
                // error={this.state.errorFinanceInd}
                // errorMessage={this.state.errorMessage}
                />
            )
        }
        else {
            return (
                <AppTextField
                    title={data.title}
                    type={type}
                    placeholder={placeholder}
                    prefix={prefix}
                    suffix={suffix}
                    onChange={onChange}
                    value={data.value}
                />
            )
        }

    }

    representativeName() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.representativeFormTitle.name}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.representativeName}
            />
        )
    }
    representativeBranchCode() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.representativeFormTitle.branchCode}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.branchCode}
            />
        )
    }
    representativeStaffCode() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.representativeFormTitle.staffCode}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.staffCode}
            />
        )
    }
    representativeProposalDate() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.representativeFormTitle.proposalDate}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.proposalDate}
            />
        )
    }

    personCoveredName() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.name}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.name}
            />
        )
    }
    personCoveredGender() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.gender}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.gender}
            />
        )
    }
    personCoveredTitle() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.title}
                value={this.state.personalDetailsData.title}
                placeholder={'Select title...'}
                options={this.state.salutationList}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().title, e)}
                error={this.state.titleErrMsg || false}
                errorMessage={this.state.titleErrMsg}
            />
        )
    }
    personCoveredIdType() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.idType}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.idType}
            />
        )
    }
    personCoveredIcNo() {
        return (
            <AppTextField
                title={this.state.personalDetailsData.idType == 'IC' ? Config.proposal.formDataMapping.step1.personCoveredFormTitle.icNo : 'Identification No.'}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.idNo}
            />
        )
    }
    personCoveredAddIDType() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.addIDType}
                disabled={true}
                value={this.state.personalDetailsData.addIDType}
                options={Config.quotation.optionItem.additionalID}
            />
        )
    }
    personCoveredAddNo() {
        return (
            <AppTextField
                title={this.state.personalDetailsData.addIDType == 'oldIcNo' ? Config.proposal.formDataMapping.step1.personCoveredFormTitle.oldIdNo : Config.proposal.formDataMapping.step1.personCoveredFormTitle.birthCertNo}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData.addIDNo}
            />
        )
    }
    personCoveredDob() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.dob}
                type={'text'}
                disabled={true}
                value={this.state.personalDetailsData?.dob && moment(this.state.personalDetailsData.dob).format('DD/MM/YYYY')}
            />
        )
    }
    personCoveredMaritalStatus() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.maritalStatus}
                value={this.state.personalDetailsData.maritalStatus}
                placeholder={'Select marital status...'}
                options={Config.proposal.optionItem.maritalStatus}
                onChange={(e) => this.handleValueChange(this.getFormFields().maritalStatus, e)}
                error={this.state.maritalStatusErrMsg || false}
                errorMessage={this.state.maritalStatusErrMsg}
            />
        )
    }
    personCoveredRace() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.race}
                value={this.state.personalDetailsData.race}
                placeholder={'Select race...'}
                options={Config.proposal.optionItem.race}
                onChange={(e) => this.handleValueChange(this.getFormFields().race, e)}
            />
        )
    }
    personCoveredReligion() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.religion}
                value={this.state.personalDetailsData.religion}
                placeholder={'Select religion...'}
                options={Config.proposal.optionItem.religion}
                onChange={(e) => this.handleValueChange(this.getFormFields().religion, e)}
            />
        )
    }
    personCoveredIsMalaysian() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.isMalaysian}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isMalaysian, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isMalaysian, 'Yes')}
                value={this.state.personalDetailsData.isMalaysian}
            />
        )
    }
    personCoveredPlaceOfBirth() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.placeOfBirth}
                type={'text'}
                placeholder={'House no./Unit no/Lot no., Block no., Residence/Building'}
                value={this.state.personalDetailsData.placeOfBirth}
                onChange={(e) => this.handleValueChange(this.getFormFields().placeOfBirth, e)}
                error={this.state.placeOfBirthErrMsg || false}
                errorMessage={this.state.placeOfBirthErrMsg}
            />
        )
    }
    personCoveredPlaceOfBirth2() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Street no./Street Name (Optional)'}
                value={this.state.personalDetailsData.placeOfBirth2}
                onChange={(e) => this.handleValueChange(this.getFormFields().placeOfBirth2, e)}
            />
        )
    }
    personCoveredPlaceOfBirth3() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Optional'}
                value={this.state.personalDetailsData.placeOfBirth3}
                onChange={(e) => this.handleValueChange(this.getFormFields().placeOfBirth3, e)}
            />
        )
    }
    birthPlaceCountry = () => {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.country}
                value={this.state.personalDetailsData.country}
                disabled={this.state.personalDetailsData.isMalaysian == 'Yes'}
                showSearch={true}
                placeholder={'Select country...'}
                // options={FormBloc.getCountrySelections(true)}
                options={this.state.personalDetailsData.isMalaysian === 'No' ? this.state.countryList?.length > 0 && this.state.countryList.filter((item) => item.code !== 'MYS') : (this.state.countryList || [])}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().country, e)}
            />
        )
    }
    birthPlaceState() {
        const country = this.state.personalDetailsData.country;
        const stateOptions = (country == 'MYS' || country == null) ? (this.state.stateList || FormBloc.getStateSelections()) : (this.state.foreignStateList || []);
        const fieldNames = (country == 'MYS' || country == null) ?
            (this.state.stateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') }) :
            (this.state.foreignStateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') });
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.state}
                value={this.state.personalDetailsData.state}
                placeholder={'Select state...'}
                options={stateOptions}
                fieldNames={fieldNames}
                onChange={(e) => this.handleValueChange(this.getFormFields().state, e)}
            />
        )
    }
    birthPlaceCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.city}
                type={'text'}
                placeholder={'Select city...'}
                value={this.state.personalDetailsData.city}
                options={
                    this.state.cityList || []
                }
                fieldNames={this.state.cityList ? { label: ('reference1'), value: ('code') } : { label: ('cityName'), value: ('cityName') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().city, e)}
            />
        )
    }
    personCoveredIsLivingInMalaysia() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.isLivingInMalaysia}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isLivingInMalaysia, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isLivingInMalaysia, 'Yes')}
                value={this.state.personalDetailsData.isLivingInMalaysia}
            />
        )
    }
    personCoveredCountry() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.country}
                disabled={this.state.personalDetailsData.isLivingInMalaysia == 'Yes'}
                value={this.state.personalDetailsData.corrCountry}
                showSearch={true}
                placeholder={'Select country...'}
                options={this.state.personalDetailsData.isLivingInMalaysia === 'No' ? this.state.countryList?.length > 0 && this.state.countryList.filter((item) => item.code !== 'MYS') : (this.state.countryList || [])}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrCountry, e)}
            />
        )
    }
    personCoveredCorrespondingAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.correspondenceAddress}
                type={'text'}
                placeholder={'House no./Unit no/Lot no., Block no., Residence/Building'}
                value={this.state.personalDetailsData.correspondenceAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().correspondenceAddress, e)}
                error={this.showerror(this.state.personalDetailsData.correspondenceAddress)}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }
    personCoveredCorrespondingAddress2() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Street no./Street Name (Optional)'}
                value={this.state.personalDetailsData.correspondenceAddress2}
                onChange={(e) => this.handleValueChange(this.getFormFields().correspondenceAddress2, e)}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }
    personCoveredCorrespondingAddress3() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Optional'}
                value={this.state.personalDetailsData.correspondenceAddress3}
                onChange={(e) => this.handleValueChange(this.getFormFields().correspondenceAddress3, e)}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }
    personCoveredState() {
        const country = this.state.personalDetailsData.corrCountry;
        const stateOptions = (country == 'MYS' || country == null) ? (this.state.stateList || FormBloc.getStateSelections()) : (this.state.corrForeignStateList || []);
        const fieldNames = (country == 'MYS' || country == null) ?
            (this.state.stateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') }) :
            (this.state.corrForeignStateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') });
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.state}
                value={this.state.personalDetailsData.corrState}
                placeholder={'Select state...'}
                options={stateOptions}
                fieldNames={fieldNames}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrState, e)}
            />
        )
    }
    personCoveredPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.postcode}
                type={'text'}
                placeholder={'Select postcode...'}
                value={this.state.personalDetailsData.corrPostcode}
                options={this.state.addressPostcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrPostcode, e)}
            />
        )
    }
    personCoveredCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.city}
                type={'text'}
                placeholder={'Select city...'}
                value={this.state.personalDetailsData.corrCity}
                options={
                    this.state.addressCityList || []
                }
                fieldNames={this.state.addressCityList ? { label: ('reference1'), value: ('code') } : { label: ('cityName'), value: ('cityName') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrCity, e)}
            />
        )
    }

    // is permanant start
    personCoveredIsPermanentAddressCorrespondenceAddress() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.isPermamentAddressCorrespondenceAddress}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isPermamentAddressCorrespondenceAddress, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isPermamentAddressCorrespondenceAddress, 'Yes')}
                value={this.state.personalDetailsData.isPermamentAddressCorrespondenceAddress}
            />
        )
    }
    personCoveredPermanentAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.permanentAddress}
                type={'text'}
                placeholder={'Enter floor / unit / street name...'}
                value={this.state.personalDetailsData.permanentAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().permanentAddress, e)}
                error={this.showExtraFormError(this.state.personalDetailsData.isPermamentAddressCorrespondenceAddress, this.state.personalDetailsData.permanentAddress, "No")}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }
    // is permanant end

    // Residential address start
    personCoveredResidentialCountry = () => {
        console.log("country", this.state.personalDetailsData.residentialCountry)
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.residentialCountry}
                type={'text'}
                placeholder={'Select country...'}
                value={this.state.personalDetailsData.residentialCountry}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialCountry, e)}
                options={this.state.countryList || FormBloc.getCountrySelections(true)}
                fieldNames={this.state.countryList ? { label: ('reference1'), value: ('code') } : {}}
                showSearch={true}
            />
        )
    }
    personCoveredIsResidentialAddressCorrespondenceAddress() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.isResidentialAddressCorrespondenceAddress}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isResidentialAddressCorrespondenceAddress, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isResidentialAddressCorrespondenceAddress, 'Yes')}
                value={this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress}
            />
        )
    }
    personCoveredResidentialAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.residentialAddress}
                type={'text'}
                placeholder={'House no./Unit no/Lot no., Block no., Residence/Building'}
                value={this.state.personalDetailsData.residentialAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialAddress, e)}
                error={this.showExtraFormError(this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress, this.state.personalDetailsData.residentialAddress, "No")}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }
    personCoveredResidentialAddress2() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Street no./Street Name (Optional)'}
                value={this.state.personalDetailsData.residentialAddress2}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialAddress2, e)}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }


    personCoveredResidentialState() {
        const country = this.state.personalDetailsData.residentialCountry;
        const stateOptions = (country == 'MYS' || country == null) ? (this.state.stateList || FormBloc.getStateSelections()) : (this.state.residentialForeignStateList || []);
        const fieldNames = (country == 'MYS' || country == null) ?
            (this.state.stateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') }) :
            (this.state.residentialForeignStateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') });
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.state}
                value={this.state.personalDetailsData.residentialState}
                placeholder={'Select state...'}
                options={stateOptions}
                fieldNames={fieldNames}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialState, e)}
            />
        )
    }
    personCoveredResidentialPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.postcode}
                type={'text'}
                placeholder={'Select postcode...'}
                value={this.state.personalDetailsData.residentialPostcode}
                options={this.state.residentialPostcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialPostcode, e)}
            />
        )
    }
    personCoveredResidentialCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.city}
                type={'text'}
                placeholder={'Select city...'}
                value={this.state.personalDetailsData.residentialCity}
                options={
                    this.state.residentialCityList || []//FormBloc.getCitySelections()
                }
                fieldNames={this.state.residentialCityList ? { label: ('reference1'), value: ('code') } : { label: ('cityName'), value: ('cityName') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialCity, e)}
            />
        )
    }

    personCoveredResidentialAddress3() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Optional'}
                value={this.state.personalDetailsData.residentialAddress3}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialAddress3, e)}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }
    // Residential address end

    personCoveredOccupation() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.occupation}
                type={'text'}
                disabled={true}
                value={this.state.displayOcc}
            />
        )
    }
    personCoveredAnnualIncome() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.annualIncome}
                placeholder={'Select annual income...'}
                onChange={(e) => this.handleValueChange(this.getFormFields().annualIncome, e)}
                // onValidate={(value) => { return !UtilBloc.validateDecimal(value) }}
                options={Config.proposal.optionItem.incomeRange}
                // errorMessage={decimalNumberValidation(this.state.personalDetailsData.annualIncome)}
                // disabled={true}
                value={this.state.personalDetailsData.annualIncome}
            />
        )
    }
    personCoveredExactAnnualIncome() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.exactAnnualIncome}
                type={'text'}
                prefix={'RM '}
                placeholder={'Enter exact annual income...'}
                onChange={(e) => {
                    if (e) {
                        let value = e;
                        if (/^\d*\.?\d*$/.test(value)) {
                            this.handleValueChange(this.getFormFields().exactAnnualIncome, value);
                        }
                        return;
                    }
                    this.handleValueChange(this.getFormFields().exactAnnualIncome, e)
                }}
                onValidate={(value) => { return !UtilBloc.validateDecimal(value) }}
                errorMessage={decimalNumberValidation(this.state.personalDetailsData.exactAnnualIncome)}
                // disabled={true}
                value={this.state.personalDetailsData.exactAnnualIncome}
            />
        )
    }
    personCoveredNatureOfBusiness() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.natureBusiness}
                type={'text'}
                disabled={true}
                value={this.state.displayNob}
            />
        )
    }
    personCoveredExactDuties() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.exactDuties}
                type={'text'}
                placeholder={'Describe the duties you\'re managing...'}
                multiline={true}
                showCount
                maxLength={1000}
                value={this.state.personalDetailsData.exactDuties}
                onChange={(e) => this.handleValueChange(this.getFormFields().exactDuties, e)}
                error={this.showerror(this.state.personalDetailsData.exactDuties)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    personCoveredMobileNo() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.mobileNo}
                type={'text'}
                placeholder={'Enter mobile phone number...'}
                value={this.state.personalDetailsData.mobileNo}
                onChange={(e) => (this.handleValueChange(this.getFormFields().mobileNo, e))}
                onValidate={(value) => { return UtilBloc.phoneNumberValidation(value) }}
                // error={this.showerror(this.state.personalDetailsData.mobileNo)}
                errorMessage={phoneNumberValidation(this.state.personalDetailsData.mobileNo)}
            />
        )
    }
    personCoveredOfficePhoneNumber() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.officePhoneNo}
                type={'text'}
                placeholder={'Enter office phone number (Optional)'}
                value={this.state.personalDetailsData.officePhoneNo}
                onChange={(e) => this.handleValueChange(this.getFormFields().officePhoneNo, e)}
                onValidate={(value) => { return value !== '' && UtilBloc.phoneNumberValidation(value) }}
                error={this.state.personalDetailsData.officePhoneNo !== '' && this.showerror(this.state.personalDetailsData.officePhoneNo)}
                errorMessage={this.state.personalDetailsData.officePhoneNo !== '' && phoneNumberValidation(this.state.personalDetailsData.officePhoneNo)}
            />
        )
    }
    personCoveredHomePhoneNumber() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.homePhoneNo}
                type={'text'}
                placeholder={'Enter home phone number (Optional)'}
                value={this.state.personalDetailsData.homePhoneNo}
                onChange={(e) => this.handleValueChange(this.getFormFields().homePhoneNo, e)}
                onValidate={(value) => { return value !== '' && UtilBloc.phoneNumberValidation(value) }}
                error={this.state.personalDetailsData.homePhoneNo !== '' && this.showerror(this.state.personalDetailsData.homePhoneNo)}
                errorMessage={this.state.personalDetailsData.homePhoneNo !== '' && phoneNumberValidation(this.state.personalDetailsData.homePhoneNo)}
            />
        )
    }
    personCoveredEmail() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.email}
                type={'text'}
                placeholder={'Enter email...'}
                value={this.state.personalDetailsData.email}
                onChange={(e) => this.handleValueChange(this.getFormFields().email, e)}
                error={this.emailValidation(this.state.personalDetailsData.email)}
                errorMessage={"Invalid email format"}
            />
        )
    }
    personCoveredCompanyName() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyName}
                type={'text'}
                placeholder={'Enter your company name...'}
                value={this.state.personalDetailsData.companyName}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyName, e)}
                onValidate={(value) => { return UtilBloc.nameValidation(value, true) }}
                error={this.showerror(this.state.personalDetailsData.companyName)}
                errorMessage={nameValidation(this.state.personalDetailsData.companyName, true)}
                maxLength={60}
            />
        )
    }
    personCoveredCompanyAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyAddress}
                type={'text'}
                placeholder={'Enter floor / unit / street name...'}
                value={this.state.personalDetailsData.companyAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyAddress, e)}
                error={this.showerror(this.state.personalDetailsData.companyAddress)}
                errorMessage={this.state.errorMessage}
                maxLength={59}
            />
        )
    }
    personCoveredCompanyAddress2() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Street no./Street Name (Optional)'}
                value={this.state.personalDetailsData.companyAddress2}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyAddress2, e)}
                maxLength={59}
            />
        )
    }
    personCoveredCompanyAddress3() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Optional'}
                value={this.state.personalDetailsData.companyAddress3}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyAddress3, e)}
                maxLength={59}
            />
        )
    }
    personCoveredCompanyCountry = () => {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyCountry}
                type={'text'}
                placeholder={'Select country...'}
                value={this.state.personalDetailsData.companyCountry}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyCountry, e)}
                options={this.state.countryList || FormBloc.getCountrySelections(true)}
                fieldNames={this.state.countryList ? { label: ('reference1'), value: ('code') } : {}}
                showSearch={true}
            />
        )
    }
    personCoveredCompanyState() {
        const country = this.state.personalDetailsData.companyCountry;
        const stateOptions = (country == 'MYS' || country == null) ? (this.state.stateList || FormBloc.getStateSelections()) : (this.state.companyForeignStateList || []);
        const fieldNames = (country == 'MYS' || country == null) ?
            (this.state.stateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') }) :
            (this.state.companyForeignStateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') });
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyState}
                value={this.state.personalDetailsData.companyState}
                placeholder={'Select state...'}
                options={stateOptions}
                fieldNames={fieldNames}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyState, e)}
            />
        )
    }
    personCoveredCompanyPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyPostcode}
                value={this.state.personalDetailsData.companyPostcode}
                placeholder={'Enter postcode...'}
                options={this.state.companyPostcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyPostcode, e)}
            />
        )
    }
    personCoveredCompanyCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyCity}
                value={this.state.personalDetailsData.companyCity}
                placeholder={'Enter city...'}
                options={
                    this.state.companyCityList || []
                }
                fieldNames={this.state.companyCityList ? { label: ('reference1'), value: ('code') } : { label: ('cityName'), value: ('cityName') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyCity, e)}
            />
        )
    }
    preferContactMode() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.preferContactMode}
                negativeButtonText={'Mobile Number'}
                positiveButtonText={'Email'}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().preferContactMode, 'Mobile Number')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().preferContactMode, 'Email')}
                value={this.state.personalDetailsData.preferContactMode}
            />
        )
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100" >
                    <div className="">
                        <div className="section_title my-4">Representative’s Details</div>
                        <div className="row m-0 w-100" >
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.representativeName()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.representativeBranchCode()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.representativeStaffCode()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.representativeProposalDate()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="section_title my-4">Person to be Covered’s Details</div>
                    <div className="row m-0 w-100">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredName()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredGender()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.personCoveredTitle()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 "></div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIdType()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIcNo()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredAddIDType()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredAddNo()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredDob()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredMaritalStatus()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredRace()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredReligion()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIsMalaysian()}
                        </div>
                        {/* <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredPlaceOfBirth()}
                        </div> */}
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-12 col-sm-12 pr-3 pl-0">
                            {this.personCoveredPlaceOfBirth()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.personCoveredPlaceOfBirth2()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredPlaceOfBirth3()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.birthPlaceCountry()}
                        </div>
                        {
                            <div className="col-lg-6 col-sm-12 row m-0 p-0">
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.birthPlaceState()}
                                </div>
                                {
                                    this.state.personalDetailsData.country == 'MYS' || this.state.personalDetailsData.country == null ?
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.birthPlaceCity()}
                                        </div> : <></>
                                }
                            </div>
                        }
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIsLivingInMalaysia()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCountry()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCorrespondingAddress()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCorrespondingAddress2()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCorrespondingAddress3()}
                        </div>
                    </div>
                    {
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.personCoveredState()}
                            </div>
                            {
                                this.state.personalDetailsData.corrCountry == 'MYS' || this.state.personalDetailsData.corrCountry == null ?
                                    <div className="col-lg-6 col-sm-12 row m-0 p-0">
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredCity()}
                                        </div>
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredPostcode()}
                                        </div>
                                    </div> : <></>
                            }
                        </div>
                    }
                    {/* <div className="row m-0 w-100 mt-2">

                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.personCoveredIsPermanentAddressCorrespondenceAddress()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {
                                this.state.personalDetailsData.isPermamentAddressCorrespondenceAddress === "No" &&
                                this.personCoveredPermanentAddress()
                            }
                        </div>
                    </div> */}

                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIsResidentialAddressCorrespondenceAddress()}
                        </div>
                        {
                            this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress === "No" &&
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.personCoveredResidentialAddress()}
                            </div>
                        }
                    </div>
                    {
                        this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress === "No" &&
                        <>
                            {/* <div className="row m-0 w-100 mt-2">
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialCountry()}
                                </div>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialAddress()}
                                </div>
                            </div> */}
                            <div className="row m-0 w-100 mt-2">
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialAddress2()}
                                </div>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialAddress3()}
                                </div>
                            </div>
                        </>
                    }

                    {
                        this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress === "No" &&
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.personCoveredResidentialState()}
                            </div>
                            {
                                this.state.personalDetailsData.residentialCountry === 'MYS' || this.state.personalDetailsData.residentialCountry == null ?
                                    <div className="col-lg-6 col-sm-12 row m-0 p-0">
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredResidentialCity()}
                                        </div>
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredResidentialPostcode()}
                                        </div>
                                    </div> : <></>
                            }
                        </div>
                    }
                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredOccupation()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredNatureOfBusiness()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredAnnualIncome()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {
                                this.state.personalDetailsData.annualIncome === '> RM200,000' &&
                                this.personCoveredExactAnnualIncome()
                            }
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredExactDuties()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredOfficePhoneNumber()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredHomePhoneNumber()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredMobileNo()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredEmail()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyName()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyCountry()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyAddress()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyAddress2()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyAddress3()}
                        </div>
                    </div>
                    {
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.personCoveredCompanyState()}
                            </div>
                            {
                                this.state.personalDetailsData.companyCountry == 'MYS' || this.state.personalDetailsData.companyCountry == null ?
                                    <div className="col-lg-6 col-sm-12 row m-0 p-0">
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredCompanyCity()}
                                        </div>
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredCompanyPostcode()}
                                        </div>
                                    </div> : <></>
                            }
                        </div>
                    }
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.preferContactMode()}
                        </div>

                    </div>
                </div >
            </>
        );
    }
}


const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(PersonalDetails));